module.exports = __webpack_public_path__ + "img/sensor-node_300x300px.45f9f3a3.jpg";